module.exports = moment;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 26
// module chunks = 0